import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Tab } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { Alert } from "react-bootstrap";

import { MULTI_CLASS_SELECT_LEARNERS_KEY } from "../../../constants";
import DoceboScheduledTraining from "../doceboScheduledTraining";
import SchooxAdHocTranscripts from "../schooxAdhocTranscripts";
import OraclelearnScheduledTraining from "../oraclelearnScheduledTraining";
import "./SelectRosterTabs.css";

const SelectRosterTabs = () => {
  let panes = [];
  // clear/reset selected course
  localStorage.removeItem("currentCourse");

  // init user view
  const user = useSelector((state) => state.auth);
  const location = useLocation();

  if (user && user.user && user.user.tabs) {
    var userTabsArray = JSON.parse(user.user.tabs);
    if (userTabsArray) {
      var uiTabs = userTabsArray.tabs;
      if (uiTabs && uiTabs.length > 0) {
        for (var tb in uiTabs) {
          if (uiTabs[tb].component === "DoceboScheduledTraining") {
            panes.push({
              menuItem: uiTabs[tb].name,
              render: () => (
                <Tab.Pane>
                  <DoceboScheduledTraining />
                </Tab.Pane>
              ),
            });
          }
          if (uiTabs[tb].component === "SchooxAdHocTranscripts") {
            panes.push({
              menuItem: uiTabs[tb].name,
              render: () => (
                <Tab.Pane>
                  <SchooxAdHocTranscripts />
                </Tab.Pane>
              ),
            });
          }
          if (uiTabs[tb].component === "OraclelearnScheduledTraining") {
            panes.push({
              menuItem: uiTabs[tb].name,
              render: () => (
                <Tab.Pane>
                  <OraclelearnScheduledTraining />
                </Tab.Pane>
              ),
            });
          }
        }
      }
    }
  } else {
    panes = [
      {
        menuItem: "Default",
        render: () => <Tab.Pane>You are not assigned to any Tabs in RapidRoster</Tab.Pane>,
      },
    ];
  }

  const [key, setKey] = useState(0);

  const hasMultiClassCachedLearners = useMemo(() => {
    try {
      const raw = sessionStorage.getItem(MULTI_CLASS_SELECT_LEARNERS_KEY);
      const parsed = JSON.parse(raw || "[]");
      return Array.isArray(parsed) && parsed.length > 0;
    } catch {
      return false;
    }
  }, [location?.state]);

  const handleTabChange = (e, { activeIndex }) => setKey({ activeIndex });

  return (
    <div className="col-md-8 offset-md-2 select-roster-tabs">
      {hasMultiClassCachedLearners && (
        <Alert variant="info" className="mt-3">
          Please select an additional training for the learners to be enrolled in.
        </Alert>
      )}
      <Tab panes={panes} defaultActiveIndex={key} className="tab-container" />
    </div>
  );
};

export default SelectRosterTabs;
